import { EncodingExtensions as Base } from 'core/extensions/EncodingExtensions'
import { isMutualAuth2StepEnabled } from 'stylewhere/shared/nfcAuthentication'
import { readNfcAuthenticatedTagWithProductInfo } from 'custom/louis-vuitton/shared/nfcAuthentication'
import { DatadogEncodingRun, EncodingValidationRequest, TmrTag } from 'stylewhere/api'
import { EncodingOperationConfig } from 'stylewhere/shared/RemoteOperation'

export class EncodingExtensions extends Base {
  /** Checks if we are in the LV OneIDTable mode and if the tag is an NFC authenticated tag.
   * If so, it reads the tag performing the mutual authentication
   * in product-informations mode
   */
  static async onTagRead(
    encodingValidation: EncodingValidationRequest,
    _tag: TmrTag,
    operationConfig: EncodingOperationConfig,
    antennaId?: string,
    datadogSession?: DatadogEncodingRun
  ) {
    if (
      _tag.uid &&
      // eslint-disable-next-line @typescript-eslint/dot-notation
      operationConfig.attributes['isOneIDTable'] === 'true' &&
      isMutualAuth2StepEnabled(operationConfig)
    ) {
      if (!antennaId) return
      const success = await readNfcAuthenticatedTagWithProductInfo(
        encodingValidation,
        _tag,
        operationConfig,
        antennaId,
        datadogSession
      )
      if (!success) return

      super.assignTagIdentifier(encodingValidation, _tag)
      return
    }

    return super.onTagRead(encodingValidation, _tag, operationConfig, antennaId, datadogSession)
  }
}
